<template>
    <tr  v-if="!subscriptionType.separator">
        <td v-if="isNormal">
            {{subscriptionType.name}}
            <span v-if="subscriptionType.unlimited_redeemable">
                ({{ $t('components.subscription_type.appointment_unlimited') }})
            </span>
            <span v-else>
                ({{ $t('components.subscription_type.appointment_number', {appointments_redeemable: subscriptionType.appointments_redeemable}) }})
            </span>
        </td>
        <!-- TODO Added logic for expiring date-->
        <td v-else-if="isCarnet">{{subscriptionType.name}} {{ $t('components.subscription_type.when_expire', {n: subscriptionType.valid_for_days}) }}</td>

        <td v-if="isNormal">{{getCurrencySymbolFromString(subscriptionType.price_currency)}}{{subscriptionType.price}}/{{ $t('unit.month') }}</td>
        <td v-else-if="isCarnet">{{getCurrencySymbolFromString(subscriptionType.price_currency)}}{{subscriptionType.price}}</td>

        <td>
            {{subscriptionType.count_active}} <a v-if="subscriptionType.count_active > 0" href="" @click.prevent.stop="$emit('show-subscribers-active', subscriptionType.id)">{{ $t('components.subscription_type.show_subscribers') }}</a>
        </td>
        <td class="text-right">
            <router-link  class="btn btn-default" :to="{ name: 'subscriptions_type_detail', params: { id: subscriptionType.id }}">
                <i class="las la-edit"></i>{{ $t('common.edit') }}
            </router-link>
        </td>
    </tr>

    <tr v-else class="row-title">
        <td class="text-uppercase" style="border:none;"><b>{{subscriptionType.separator_name}}</b></td>
        <td class="text-uppercase" style="border:none;"><b>{{ $t('common.price') }}</b></td>
        <td class="text-uppercase" style="border:none;"><b>{{ $t('components.subscription.active_subscribers') }}</b></td>
        <td style="border:none;"></td>
    </tr>
</template>

<script>
    import {SUBSCRIPTION_CATEGORY} from "../../common/constants";
    import {Utils} from "@/common/utils";

    export default {
        name: "SubscriptionRow",
        props: {
            subscriptionType: {
                type: Object,
                require: true
            }
        },
        computed: {
            isNormal: function () {
                return this.subscriptionType.category === SUBSCRIPTION_CATEGORY.NORMAL
            },
            isCarnet: function () {
                return this.subscriptionType.category === SUBSCRIPTION_CATEGORY.CARNET
            }
        },
        methods: {
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            }
        }
    }
</script>
